import {h, Fragment} from "preact"
import { SerpElement, useCurrencyFormatting } from "@nosto/preact"
import { useEffect } from "preact/hooks";
import { productImagePlaceholder, imageResizer } from "../helpers"

export default function Product({ product }) {
    const { format } = useCurrencyFormatting()
    const tags = [
        product.onSale
            ? {
                  label: "Sale",
                  class: "ns-badge ns-badge-green-outline ns-d-inline-block ns-text-align-center"
              }
            : undefined
    ].filter(v => !!v)

    const swatches = [];
    let seenColors = [];
    let hiddenColorsField = product.customFields.filter((obj) => obj.key == "custom_fields-hidden_variants");
    let hiddenColors = hiddenColorsField.length > 0 ? hiddenColorsField[0].value.split(",") : [];
    let swatchCount = 0;
    let altImg = "";

    product.skus?.forEach(el => { 
        el.customFields.forEach(field => {
            if(field.key == "color" && !seenColors.includes(field.value) && !hiddenColors.includes(field.value)) {
                seenColors.push(field.value);
                product.alternateImageUrls?.some((img, idx) => {
                    if(img == el.imageUrl) {
                        altImg = product.alternateImageUrls[idx + 1];
                        return true;
                    }
                    altImg = product.alternateImageUrls[0];
                })
                swatches.push({color: field.value, image: el.imageUrl, altImg: altImg, price: format(el.price).toString().replace(".00", ""), listPrice: format(el.listPrice).toString().replace(".00", ""), id: el.id})
            }
        })
    })

    useEffect(() => {
        //control Swatch clicks
        let swatchElems = document.querySelectorAll(".ns-serp .ns-product .product-option-item--color:not(.plus)");
        swatchElems.forEach(function(elem) {
            elem.addEventListener("click", function(e) {
                let swatchInfo = JSON.parse(e.currentTarget.dataset["swatch"]);
                let color = swatchInfo.color,
                    image = swatchInfo.image,
                    altImg = swatchInfo.altImg,
                    skuId = swatchInfo.id, 
                    price = swatchInfo.price,
                    listPrice = swatchInfo.listPrice;

                // if(e.currentTarget.dataset["firstVariant"]) { e.currentTarget.closest(".ns-product").classList.remove("variant-selection") } else { e.currentTarget.closest(".ns-product").classList.add("variant-selection") }
                e.currentTarget.closest("fieldset").querySelector("[data-product-option-group-selected-text]").innerText = color;
                e.currentTarget.closest(".ns-product").querySelector("img.main-image").src = imageResizer(image, 300);
                e.currentTarget.closest(".ns-product").querySelector("img.secondary-image").src = imageResizer(altImg, 300);
                e.currentTarget.closest(".ns-product").href = e.currentTarget.closest(".ns-product").href.split("?")[0] + "?variant=" + swatchInfo.id;
            });
        });
    }, [swatches?.length > 0])

    

    return (
        <SerpElement
            as="a"
            hit={product}
            class="ns-product ns-border-box ns-clickable ns-text-undecorated ns-color-inherit ns-col-12 ns-col-xs-6 ns-col-l-3 ns-mx-0 product-card"
        >
            <div class="product-card--images">
                <img
                    class="ns-w-100 ns-h-auto main-image"
                    src={imageResizer(product.imageUrl, 400) ?? productImagePlaceholder}
                    alt={product.name}
                    width="300"
                    height="400"
                />
                {product.alternateImageUrls && product.alternateImageUrls.length > 0 && (
                    <img
                        class="ns-w-100 ns-h-auto secondary-image"
                        src={imageResizer(product.alternateImageUrls[0], 400) ?? productImagePlaceholder}
                        alt={product.name}
                        width="300"
                        height="400"
                    />
                )}
                {product.listPrice && product.listPrice > product.price && (
                    <div class="collection-item__badge d-block" data-collection-item-sale-badge="">On sale</div>
                )}
            </div>
            <div class="ns-relative ns-mt-2 product-card--content" data-nosto-element="product">
                <div class="ns-clipped ns-text-four-lines ns-text-md-three-lines ns-mb-2 ns-font-4 product__title heading-6">{product.name}</div>
                <div class="product__meta">
                    {product.listPrice && product.listPrice > product.price && (
                        <>
                            <span class="sale-price" data-collection-item-sale-price="">{format(product.price).toString().replace(".00", "")}</span>
                            <s data-collection-item-compare-price="">{format(product.listPrice).toString().replace(".00", "")}</s>
                        </>
                    )}
                    {!product.listPrice || product.listPrice == product.price && (
                        <p class="collection-item__price ns-price" data-collection-item-price="">
                            <span data-collection-item-sale-price="">{format(product.price).toString().replace(".00", "")}</span>
                        </p>
                    )}
                </div>
                { swatches?.length > 0 && (
                    <div class="product-options">
                        <fieldset class="product-option" data-product-option-group="" data-option-name="color" data-option-index="1" data-type="swatch">
                            <legend>
                                <strong>Color: </strong><span data-product-option-group-selected-text="">{swatches[0].color}</span>
                            </legend>
                            <div class="product-option__option-values">
                                {
                                    swatches?.map((sku, idx) => {
                                        let jointColorName = sku.color.toString().toLowerCase().split(" ").join("-");
                                        let productHandle = product.url.toString().toLowerCase().split("/products/")[1];
                                        let swatchImg = "//southerntide.com/cdn/shop/files/" + productHandle + "-" + jointColorName + "_40x.jpg";
                                        if(idx === 0) {
                                            return(
                                                <div class="product-option-item product-option-item--color" data-product-option-item="" data-swatch={JSON.stringify(sku)} data-first-variant>
                                                    <input type="radio" id={`product-swatch-template--${product.productId}-${sku.id}-${jointColorName}`} value={sku.color} 
                                                        name={`product-swatch-template--${product.productId}-color`}
                                                        checked
                                                        data-product-option="" data-available="true" data-variant-id={sku.id} data-option-index="1" 
                                                        data-type="radio" data-current-price={sku.price} data-compare-price={sku.listPrice} data-selected-text={sku.color} />
                                                    <label for={`product-swatch-template--${product.productId}-${sku.id}-${jointColorName}`}>
                                                        <div class="product-option-item__swatch" style={`background-image:url(${swatchImg});`}></div>
                                                        <span class="visually-hidden">{sku.color}</span>
                                                    </label>
                                                </div>
                                            )
                                        } else if(idx <= 5) {
                                            return(
                                                <div class="product-option-item product-option-item--color" data-product-option-item="" data-swatch={JSON.stringify(sku)}>
                                                    <input type="radio" id={`product-swatch-template--${product.productId}-${sku.id}-${jointColorName}`} value={sku.color} 
                                                        name={`product-swatch-template--${product.productId}-color`}
                                                        data-product-option="" data-available="true" data-variant-id={sku.id} data-option-index="1" 
                                                        data-type="radio" data-current-price={sku.price} data-compare-price={sku.listPrice} data-selected-text={sku.color} />
                                                    <label for={`product-swatch-template--${product.productId}-${sku.id}-${jointColorName}`}>
                                                        <div class="product-option-item__swatch" style={`background-image:url(${swatchImg});`}></div>
                                                        <span class="visually-hidden">{sku.color}</span>
                                                    </label>
                                                </div>
                                            )
                                        } else {
                                            swatchCount = swatchCount + 1
                                            return(
                                                <div style="display:none;" class="product-option-item product-option-item--color" data-product-option-item="" data-swatch={JSON.stringify(sku)}>
                                                    <input type="radio" id={`product-swatch-template--${product.productId}-${sku.id}-${jointColorName}`} value={sku.color} 
                                                        name={`product-swatch-template--${product.productId}-color`}
                                                        data-product-option="" data-available="true" data-variant-id={sku.id} data-option-index="1" 
                                                        data-type="radio" data-current-price={sku.price} data-compare-price={sku.listPrice} data-selected-text={sku.color} />
                                                    <label for={`product-swatch-template--${product.productId}-${sku.id}-${jointColorName}`}>
                                                        <div class="product-option-item__swatch" style={`background-image:url(${swatchImg});`}></div>
                                                        <span class="visually-hidden">{sku.color}</span>
                                                    </label>
                                                </div>
                                            )
                                        }
                                    })
                                }
                                { swatchCount > 0 && (
                                    <>
                                        <div class="showMoreSwatches desktop">+ {swatchCount} </div>
                                        <div class="showMoreSwatches mobile">+ {swatchCount + 3} </div>
                                    </>
                                )}
                            </div>
                        </fieldset>
                    </div>
                )}
            </div>
        </SerpElement>
    )
}
